import { useQuery } from '@tanstack/react-query';

const svgToDataUrl = (svg: string) =>
  `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;

const fetchSvgDataUrl = async (url: string) => {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`svg fetch ${res.status}`);
  return svgToDataUrl(await res.text());
};

export function useSvgDataUrl(url: string | undefined) {
  const { data } = useQuery({
    queryKey: ['svg-data-url', url],
    queryFn: () => fetchSvgDataUrl(url as string),
    enabled: !!url,
    staleTime: Infinity,
    cacheTime: Infinity,
  });

  return data;
}
